import React, {useState, useEffect, useRef} from 'react';
import Cab from './Cab/Cab';
import Road from './Road';
import Window from './Window';
import Cheats from './Cheats';
import RoadObjectEditor from './RoadObjectEditor';
import Pedals from './Cab/Pedals';
import CrossingInterstitial from './CrossingInterstitial';
import FailureScreen from './FailureScreen';

const Crossing = props => {
  const preventStoppingWarnings = false;


  const data = props.data;
  // const [crossingIdx, setCrossingIdx] = useState(0);
  const [view, setView] = useState('default');
  const [showFail, setShowFail] = useState(false);
  const [hitbyTrain, setHitbyTrain] = useState(false);
  const [showInterstitial, setShowInterstitial] = useState(false);
  const [didStopCorrectly, setDidStopCorrectly] = useState(false);
  const [isFarAway, setIsFarAway] = useState(false);
  const [isStoppedCorrectly, setIsStoppedCorrectly] = useState(false);
  const [lookOverMouseDown, setLookOverMouseDown] = useState(false);
  const [editedRoadObject, setEditedRoadObject] = useState('');
  const [objectHighlight, setObjectHighlight] = useState(null);  
  const [completedIntersections, setCompletedIntersections] = useState([]);
  //const [gpsAudioIndex, setGpsAudioIndex] = useState(0);
  const [intersectionFailureScreen, setIntersectionFailureScreen] = useState('intersection');
  const [directionsLooked, setDirectionsLooked] = useState([]);
  const [showLookArrows, setShowLookArrows ] = useState(false);
//  const [inZone, setInZone] = useState(false);

  const [hazardsOn, setHazardsOn] = useState(false);
  const [windowsDown, setWindowsDown] = useState(false);
  const [fmRadioOn, setFmRadioOn] = useState(false);
  const [cbRadioOn, setCbRadioOn] = useState(false);


  // 'right' when train is visible on the right, 'left' when visible looking left
  const [sideTrainVisible, setSideTrainVisible] = useState(null);
  const [rightSideView, setRightSideView] = useState(null);
  const [leftSideView, setLeftSideView] = useState(null)
  const [afterPop, setAfterPop] = useState(false);
  const [enableHazard, setEnableHazard] = useState(false);
  const [hazardsTurnedOnCorrectly, setHazardsTurnedOnCorrectly] = useState(false)

  /**
   * Movement
   */
  const fps = 30;

  // frames per speed unit change
  const DECELERATION = 2;
  const ACCELERATION = 2;

  //position is truck position x arbitrary length units from beginning
  const [position, setPosition] = useState(0);
  const stoppedPosition = React.useRef(position);
  const stoppedTimeoutId = React.useRef(null);
  const intersectionIndex = (data.intersections || []).findIndex(e => {
    return position >= (e-1000) && position < e
  });
  const nextIntersectionIndex = (data.intersections || []).findIndex(e => {
    return position < e
  });
  const distanceFromCrossing = Math.round((((props.data.intersections?props.data.intersections[nextIntersectionIndex]:props.data.stop) - position) / (props.data.feetlength || 8.75))+15) 
  const inZone = distanceFromCrossing <= 50;
  const audioToProcess = useRef(props?.data?.audioTriggers?.map( e => ({ ...e, processed: false})) || [])
  const showCheats = document.location.href.indexOf('showCheats') > -1;



  // const gpsAudioMap = [
  //   '500_ft', 'link_ln', 'recalculating', '500_ft', 'route_23', 'recalculating', '500_ft'
  // ]
  // const gpsPositionMap = [
  //   1000, 7000, 16000, 18000, 23000, 26300, 28400
  // ]

  //truck speed in mph
  const [speed, setSpeed] = useState(data.initialSpeed || 0);
  const [targetSpeed, setTargetSpeed] = useState(data.initialSpeed || 0);
  const isMoving = speed > 0;

  const [roadClear, setRoadClear] = useState(false);

  // in last crossing, get current intersection id
  //const currentIntersectionIndex = completedIntersections.findIndex(e => e === false);

  const checkPosition = brakePressed => {
    //checkForSlowdown(brakePressed)
    if (!isMoving) {

      // let stoppedfeet=Math.round(((data.stopbeforefeet - data.slowdown.end) - (position-data.slowdown.end)) * (data.feetlength)/(data.stopbeforefeet - data.slowdown.end));

    }else{
      if (stoppedTimeoutId.current !== null){
        clearTimeout(stoppedTimeoutId.current)
        stoppedTimeoutId.current = null;
      }

    }

    if (data.intersections) {
      checkForIntersection();
    } else {
      checkForRailroadStop();
    }
    if (data.audioTriggers?.length > 0){
      checkForGPSAudio();
    }
    if (checkForFinishLine() && !showInterstitial) {
      if (!hazardsOn && hazardsTurnedOnCorrectly) {
        props.scoring.setScore('turnedOnHazards', props.data.tripId, props.data.crossingId)
      }
      nextCrossing();
    }
    // check for slow down and update hazards at slow down zone.
    if (data.slowdown && position > data.slowdown.start && position < data.slowdown.end) {
      if (speed < data.initialSpeed){
        props.scoring.setScore('slowdown', props.data.tripId, props.data.crossingId)
      }
      if (hazardsOn) {
        setHazardsTurnedOnCorrectly(true)
      }
    }
  };

  // check to see if user slows down in correct region
  // const checkForSlowdown = (brakePressed) => {
  //   if (data.slowdown && position > data.slowdown.start && position < data.slowdown.end && brakePressed) {
  //     props.scoring.setScore('slowdown', props.data.tripId, props.data.crossingId, true)
  //   }
  // }

  const checkForGPSAudio = () => {
    audioToProcess.current &&  audioToProcess.current.forEach((e,i) => {
        if (e.processed === true) return;
        if (e.position > position) return
        audioToProcess.current[i].processed = true
        props.audioController.playAudioByName(e.audio);
    })

    //ToDo: refactor to look for data.audioTriggers and fire any that are needed.
    // if (position > gpsPositionMap[gpsAudioIndex]) {
    //   props.audioController.playAudioByName(`gps_${gpsAudioMap[gpsAudioIndex]}`);
    //   setGpsAudioIndex(gpsAudioIndex+1);
    // }
  }

  const checkForRailroadStop = () => {
    let rangeStart = data.stop - 1000;
    let rangeEnd = data.stop;
    if (position < rangeStart && !isMoving) {
      // need to start timer for stoped too long away from Crossing.
      stoppedPosition.current = position;
      console.log("FARAWAY: Start Stopped timer")
      if (!stoppedTimeoutId.current && !preventStoppingWarnings){
        stoppedTimeoutId.current = setTimeout(() => {
          setIsFarAway(true);
          stoppedTimeoutId.current = null; 
        }, (60000));
      }

    } else if (position >= rangeStart && position < rangeEnd) {
      setShowLookArrows(true)
      if (!isMoving) {
        setIsStoppedCorrectly(true);
        setDidStopCorrectly(true);
        if (!hazardsOn && hazardsTurnedOnCorrectly) {
          setHazardsTurnedOnCorrectly(false)
        }
        if (!stoppedTimeoutId.current && roadClear && !preventStoppingWarnings){
          stoppedTimeoutId.current = setTimeout(() => {
            setAfterPop(true)
            stoppedTimeoutId.current = null; 
          }, (60000));
        }
      } 
    } else if (position >= rangeEnd && !didStopCorrectly) {
      failedStop();
    } else if (position >= rangeEnd && didStopCorrectly && !roadClear) {
      // if you exit the zone without waiting for the road to clear. Show the "advancedBeforeClear" dialog.
      setHitbyTrain(true);
    } else if (position >= rangeEnd && didStopCorrectly && roadClear && !checkForFinishLine()) {
      console.log("NEW IN ZONE" , position);
      //setInZone(true)
      checkCabStatus()
      if (!isMoving && !stoppedTimeoutId.current && !preventStoppingWarnings){
        stoppedTimeoutId.current = setTimeout(() => {
          setAfterPop(true);
          stoppedTimeoutId.current = null; 
        }, (6000));
      }
    }
  }
  const checkForFinishLine = () => {
    return position > props.data.finishLine
  }
  const checkForIntersection = () => {
    if (intersectionIndex > -1) {
      setShowLookArrows(true)
      if (!isMoving) {
        setIsStoppedCorrectly(true);
        const newCompletedIntersections = [...completedIntersections];
        newCompletedIntersections[intersectionIndex] = true;
        setCompletedIntersections(newCompletedIntersections);
        if (intersectionIndex === 2) {
          setIntersectionFailureScreen('forward')
        }
        if (!stoppedTimeoutId.current && !preventStoppingWarnings){
          // Stoped correctly timer
          stoppedTimeoutId.current = setTimeout(() => {
            setAfterPop(true)
            stoppedTimeoutId.current = null; 
          }, (60000));
        }
      }
      else {
        setIsStoppedCorrectly(false);
      }
    }else{
      setShowLookArrows(false)
      if (!isMoving) {
        // need to start timer for stoped too long away from Crossing.
        stoppedPosition.current = position;
        console.log("FARAWAY: Start Stopped timer")
        if (!stoppedTimeoutId.current && !preventStoppingWarnings){
          stoppedTimeoutId.current = setTimeout(() => {
            setIsFarAway(true);
            stoppedTimeoutId.current = null; 
          }, (60000));
        }
  
      }
    }


    let previousIntersectionIndex = data.intersections.length-1 - [...data.intersections].reverse().findIndex(e => position > e);
    // some hacky math to make the value -1 instead of length if we don't find an index
    previousIntersectionIndex = previousIntersectionIndex === data.intersections.length ? -1 : previousIntersectionIndex;

    if (previousIntersectionIndex > -1 && !completedIntersections[previousIntersectionIndex]) {
      failedStop();
    }
    if (position > props.data.failurePosition) {
      failedStop();
    }
  }

  const checkCabStatus = () =>{
    console.log("checkCabStatus windowsDown" , windowsDown);
    console.log("fmRadioOn" , fmRadioOn);
    console.log("cbRadioOn" , cbRadioOn);
      //is the window down while crossing?
    if (windowsDown){
      props.scoring.setScore('windowsDown', props.data.tripId, props.data.crossingId, true);      
    } 
    //is the radio on while crossing?
    if (fmRadioOn ) {  
      props.scoring.setScore('radioNotDistraction', props.data.tripId, props.data.crossingId, false);
    } 
    //is the cbradio on while crossing?
    if (cbRadioOn ) {     
      props.scoring.setScore('cbNotDistraction', props.data.tripId, props.data.crossingId, false);  
    }
  }

  const setScore = (action, arrayFlag=false, tripId=props.data.tripId) => {
    // pass this function to children rather than method from scoring.js
    // this way we don't have to pass trip and array IDs everywhere
    const arrayId = arrayFlag ? props.data.crossingId : null;
    console.log("Crossing setScore() action" , action);  
    if (action !== 'noPhone') {
      if (action === 'turnedOnHazards' && (tripId !== 1 || props.data.crossingId !== 1)) {
        // hazards only relevant in trip 1 crossing 1
        return
      }      
      props.scoring.setScore(action, tripId, arrayId, true);
    } else {
      props.scoring.setPhoneFalse(tripId);
    }

    console.log("props.scoring.getScore(props.data.tripScoreId)" , props.scoring.getScore(props.data.tripId))
    
  }

  const nextCrossing = () => {
      // Now show correct feedback and set speed
      if (!showFail) {
        setShowInterstitial(true);
        // set scores that all crossing have in common
        props.scoring.setMultiple(['correctStop', 'movedForward'], props.data.tripId, props.data.crossingId);
        // set scores for individual crossings
        if (props.data.tripId === 2 && props.data.crossingId === 2) {
          props.scoring.setScore('noGPS', props.data.tripId, props.data.crossingId, true);
          if (directionsLooked.length === 6) {
            props.scoring.setScore('lookedBothWays', props.data.tripId, props.data.crossingId, true);
          } 
        } else if (directionsLooked.length === 2) {
          props.scoring.setScore('lookedBothWays', props.data.tripId, props.data.crossingId, true);
        }
        if (props.data.tripId === 1 && props.data.crossingId === 1) {
          props.scoring.setScore('followedFlagger', props.data.tripId, props.data.crossingId, true);
        }
      }
      props.scoring.getScore(props.data.crossingId)
      console.log("props.scoring.getScore(props.data.tripScoreId)" , props.scoring.getScore(props.data.crossingId))
  }

  const failedStop = () => {
    // This should also turn down the volume on the truck engine sound
    if (!showInterstitial) {
      props.audioController.removeAudio('longLongShortLongHorn');
      setShowFail(true);
    }
  }
  const handleRoadClear = () => {
    console.log("handleRoadClear() roadClear" , roadClear);
    setRoadClear(true)
    // start timer for stopped at tracks
    if (!isMoving && !stoppedTimeoutId.current && !preventStoppingWarnings){
      stoppedTimeoutId.current = setTimeout(() => {
        setAfterPop(true)
        stoppedTimeoutId.current = null; 
      }, (60000));
    }
  }

  // const failedTrainStop =() =>{ // failed to wait for road to clear.
  //   if (!showInterstitial) {
  //     setHitbyTrain(true);
  //   }
  // }

  // const motionCompleted =(value) => {  // motionComplete is the same as roadClear
  //   if(value==true){
  //     setTimeout(() => {
  //       setAfterPop(true)
  //     }, (60000));
  //   }
  // }
  //const handleEnterZone = () => {
    //console.log("handleEnterZone()" );
    //setInZone(true)   
  //}

  const turn = (dir, intersectionId) => {
    if (intersectionId === 2 && dir === 'right') {
      props.audioController.playAudioByName('crossingComplete3a');
      props.scoring.setScore('slowdown', props.data.tripId, props.data.crossingId, true);
      setSpeed(5);
      //setInZone(true)
      checkCabStatus()
      setTimeout(() => {
        nextCrossing();
      }, 3000)
    } else {
      setIntersectionFailureScreen(`${dir}-${intersectionId}`)
      setTimeout(() => {
        failedStop();
      }, 500)
      
    }
  }

  useEffect(() => {
    if (props.data.intersections) {
      setCompletedIntersections(props.data.intersections.map(e => false));
    }
    props.scoring.resetCrossingScore(props.tripId,props.data.crossingId)
    return props.audioController.removeAllAudio
  }, [])

  useEffect(() => {
    if (!lookOverMouseDown) {
      setView('default');
    }
  }, [lookOverMouseDown, setView])

  useEffect(() => {
    checkPosition()
    if (speed > 0 && !checkForFinishLine()) {
      setIsStoppedCorrectly(false);
      const newPosition = (position + (speed*(props.data.speedFactor||1)));
      const frameTime = Math.ceil(1000 / fps);
      let timeout = setTimeout(() => setPosition(newPosition), frameTime);
      // cleanup timeout on unmount
      return () => clearTimeout(timeout)
    }
  }, [isMoving, position]);

  useEffect(() => {
    if ((hitbyTrain || showFail || afterPop || isFarAway) && speed !== 0 ){
      setTargetSpeed(0)
      setSpeed(0)
      return;
    }
    if (targetSpeed > speed) {
      setTimeout(() => setSpeed(speed + 1), (1000 / fps) * ACCELERATION)
    } else if (speed > targetSpeed) {
      if (speed === 1) props.audioController.playAudioByName('truck_stopping');
      setTimeout(() => setSpeed(speed - 1), (1000 / fps) * DECELERATION)
    }
  }, [targetSpeed, speed]);
  return (
    <div className={`Crossing ${data.class || ''}`}>

      {afterPop && 
      	<FailureScreen audioController={props.audioController} data={props.data.waitedtoolongPopup} resetCrossing={props.resetCrossing} />
      }
      {showFail && 
      	<FailureScreen audioController={props.audioController} data={props.data.intersections ? props.data.intersectionFailureScreens[intersectionFailureScreen] : props.data.failureScreen} resetCrossing={props.resetCrossing} revisitOrientation={props.revisitOrientation} />
      }
      {hitbyTrain && 
      	<FailureScreen audioController={props.audioController} data={props.data.advancedBeforeClear} resetCrossing={props.resetCrossing} revisitOrientation={props.revisitOrientation} />
      }
      {isFarAway && 
      	<FailureScreen audioController={props.audioController} data={props.data.farawayPopup} resetCrossing={props.resetCrossing} />
      }


 

        {/* road + signs/lines/obstacles etc */}
        <Road
          view={view}
          class={data.key}
          stops={data.stops}
          position={position}
          roadItems={data.roadItems}
          roadSegments={data.roadSegments}
          editedRoadObject={editedRoadObject}
          origin={{x: '38.5%', y: '50.6%'}} 
          objectHighlight={objectHighlight}
          roadEvents={data.roadEvents}
          isStoppedCorrectly={isStoppedCorrectly}
          didStopCorrectly={didStopCorrectly}     
          renderDistance={data.renderDistance}   
          setShowFail={setShowFail}
          curvedRoadData={props.data.curvedRoadEvent}
          roadOverlay={props.data.roadOverlay}
          renderDistanceBehind={props.data.renderDistanceBehind}
          failedStop={failedStop}
          setSideTrainVisible={setSideTrainVisible}
          setRightSideView={setRightSideView}
          setLeftSideView={setLeftSideView}
          audioController={props.audioController}
          crossingOver={showFail || showInterstitial}
          roadClear={handleRoadClear}
          // enterZone={handleEnterZone}   
          crossingFinished={checkForFinishLine}
          distanceFromCrossing = {distanceFromCrossing}

        />
        {showCheats &&
          <Cheats
            scoring={props.scoring} 
            setScoring={props.setScoring} 
            setSpeed={setSpeed} 
            crossingComplete={props.crossingComplete} 
            setTargetSpeed={setTargetSpeed} 
            checkPosition={() => checkPosition(true)}
          />
        }
        <RoadObjectEditor 
          setEditedRoadObject={setEditedRoadObject} 
          roadItems={data.roadItems} 
          setObjectHighlight={setObjectHighlight} 
        />
        <Window 
          direction={view !== 'default' ? view : 'forward'} 
          class={data.key} data={data.windows} 
          setView={setView} 
          setLookOverMouseDown={setLookOverMouseDown} 
          intersectionIndex={intersectionIndex}
          trainShowing={sideTrainVisible || props.data.staticSideTrain || null}
          windowsDown={windowsDown}
          rightSideView={rightSideView}
          leftSideView={leftSideView}
        />
        <Cab 
          view={view}
          speed={speed}
          audioController={props.audioController}
          isStoppedCorrectly={isStoppedCorrectly}
          showLookArrows={showLookArrows}
          setView={updatedView => setView(updatedView)}
          lookOverMouseDown={lookOverMouseDown} 
          setLookOverMouseDown={setLookOverMouseDown}
          intersectionIndex={intersectionIndex}
          turn={turn}
          data={props.data.cab || {}}
          crossingOver={showFail || showInterstitial}
          setScore={setScore}
          setDirectionsLooked={setDirectionsLooked}
          directionsLooked={directionsLooked}
          roadClear={roadClear}
          inZone={inZone}
          windowsDown={windowsDown}
          setWindowsDown={setWindowsDown}
          fmRadioOn={fmRadioOn}
          setFmRadioOn={setFmRadioOn}
          cbRadioOn={cbRadioOn}
          hazardsOn={hazardsOn}
          setHazardsOn = {setHazardsOn}
          setCbRadioOn={setCbRadioOn}

          distanceFromCrossing = {distanceFromCrossing}


        />
        { 
          view === 'default' && showInterstitial && (
            <CrossingInterstitial
              setShowInterstitial={setShowInterstitial} 
              crossingComplete={props.crossingComplete} 
              data={props.data.crossingInterstitial}
              currentRoute={props.scoring.getCurrentRoute()}
              tripId={props.data.tripId}
              crossingId={props.data.crossingId}
              audioController={props.audioController}
            />
        )}
        {
          view === 'default' && <Pedals 
            didStopCorrectly={didStopCorrectly} 
            setSpeed={updatedSpeed => setTargetSpeed(updatedSpeed)} 
            speed={speed} 
            audioController={props.audioController} 
            nextCrossing={nextCrossing} 
            checkPosition={brakePressed => checkPosition(brakePressed)}
            failedStop={failedStop}
            isMoving={isMoving}
            class={'placeholder'}
          />
        }


      {/*preload crossing images  */}
      <div className={`preload_Road ${data.key}`}/>
      <div className={`preload_Window ${data.key}`}/>
    </div>
  )
};

export default Crossing